import { render, staticRenderFns } from "./areaDialog.vue?vue&type=template&id=1c064cb4&scoped=true&"
import script from "./areaDialog.vue?vue&type=script&lang=js&"
export * from "./areaDialog.vue?vue&type=script&lang=js&"
import style0 from "./areaDialog.vue?vue&type=style&index=0&id=1c064cb4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c064cb4",
  null
  
)

export default component.exports